/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The status of the capability requested for an account.
 */
export const CapabilityStatus = {
  Enabled: "enabled",
  Disabled: "disabled",
  Pending: "pending",
  InReview: "in-review",
} as const;
/**
 * The status of the capability requested for an account.
 */
export type CapabilityStatus = ClosedEnum<typeof CapabilityStatus>;

/** @internal */
export const CapabilityStatus$inboundSchema: z.ZodNativeEnum<
  typeof CapabilityStatus
> = z.nativeEnum(CapabilityStatus);
/** @internal */
export const CapabilityStatus$outboundSchema: z.ZodNativeEnum<
  typeof CapabilityStatus
> = CapabilityStatus$inboundSchema;
